import { ContractorCardAlert } from "./ContractorCardAlert";
import { useContractorCardContext } from "../context";
import { ContractorCardLoading } from "./ContractorCardLoading";
import { ContractorCardDetails } from "./ContractorCardDetails";
import { ContractorCardUpload } from "./ContractorCardUpload";
import PageHeader from "@/components/PageHeader";
import { useContractorCardBreadcrumb } from "../hooks";
import { Separator } from "@/components/ui/separator";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useTranslation } from "react-i18next";
import { FilePreviewDialog } from "@/components/file-preview/FilePreviewDialog";

export const ContractorCardContent = () => {
  const { t } = useTranslation();
  const { loadingState, errorState, previewDialog, handleClosePreview } =
    useContractorCardContext();
  const breadcrumbItems = useContractorCardBreadcrumb();

  if (loadingState.isLoading) return <ContractorCardLoading />;
  if (errorState.error) return <ContractorCardAlert />;

  return (
    <>
      <PageHeader breadcrumbItems={breadcrumbItems} />
      <Card>
        <CardHeader>
          <CardTitle>{t("contractorCards.title.single")}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <ContractorCardDetails />
          <Separator />
          <ContractorCardUpload />
        </CardContent>
      </Card>

      {previewDialog && (
        <FilePreviewDialog
          open={Boolean(previewDialog)}
          onClose={handleClosePreview}
          fileUrl={previewDialog.fileUrl}
          fileName={previewDialog.fileName}
        />
      )}
    </>
  );
};
